

export const  GET_SEARCH_PRODUCT_REQUEST  = "GET_SEARCH_PRODUCT_REQUEST"
export const  GET_SEARCH_PRODUCT_SUCCESS  = "GET_SEARCH_PRODUCT_SUCCESS"
export const  GET_SEARCH_PRODUCT_FAILURE  = "GET_SEARCH_PRODUCT_FAILURE"


